import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/authGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_LOGS = 'logs_';

const loggingMenu: RouteRecordRaw[] = [
  {
    path: '/logs/logging/',
    name: `${PREFIX_LOGS}Logging`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS,
      childRolePermission: [
        ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS_LOGGING,
        ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS_LOGGING_TREND,
      ],
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'keyword-logging',
        name: `${PREFIX_LOGS}Keyword Logging`,
        component: () => import('../views/loggingView/LoggingView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS_LOGGING,
        },
      },
      {
        path: 'logging-trend',
        name: `${PREFIX_LOGS}Logging Trend`,
        component: () => import('../views/loggingTrendView/LoggingTrendView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS_LOGGING_TREND,
          requiresESLog: true,
        },
      },
    ],
  },
];

const streamMenu: RouteRecordRaw[] = [
  {
    path: '/logs/stream/',
    name: `${PREFIX_LOGS}Stream`,
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS,
      childRolePermission: [ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS_LIVE_TAIL],
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'live-tail',
        name: `${PREFIX_LOGS}Live Tail`,
        component: () => import('../views/liveTailView/LiveTailView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_LOGS_LIVE_TAIL,
        },
      },
    ],
  },
];

const getLoggingNaviMenu = () => {
  return extractAccessibleRoutes(loggingMenu);
};

const getStreamNaviMenu = () => {
  return extractAccessibleRoutes(streamMenu);
};

export { loggingMenu, getLoggingNaviMenu, streamMenu, getStreamNaviMenu };
